module.exports = __webpack_public_path__ + "img/google-news-source.e94ab421.svg";